<template>
  <v-card class="menu__card">
    <section class="menu__user__data">
      <section class="header">
        <v-icon size="34px" color="primary">
          mdi-account-circle-outline
        </v-icon>

        <section class="user__name">
          <span>
            <TooltipDescription
              :resource="connectedUser.fullName.toUpperCase()"
              :maxWidth="'170px'"
            />
          </span>
          <small>
            <TooltipDescription
              :resource="connectedUser.email"
              :maxWidth="'180px'"
            />
          </small>
        </section>
      </section>

      <section class="details">
        <section class="detail">
          <small>{{ $t("headers.unity") }}</small>
          <span>
            <TooltipDescription
              :resource="connectedUser.unityName"
              :maxWidth="'200px'"
            />
          </span>
        </section>

        <Divider />

        <section class="detail">
          <small>{{ $t("headers.profile") }}</small>
          <span>{{ connectedUser.profileName }}</span>
        </section>
      </section>
    </section>

    <section class="actions">
      <section class="action" @click="changeChangeUnityProfileStatus">
        <v-icon size="18">mdi-swap-horizontal</v-icon>
        <span> {{ $t("buttons.change_unity_profile") }} </span>
      </section>

      <section class="action" @click="openResetPassword">
        <v-icon size="18">mdi-lock-outline</v-icon>
        <span> {{ $t("buttons.reset_password") }} </span>
      </section>

      <section class="action action--logout" @click="logout">
        <v-icon size="18">mdi-arrow-left-bold-circle-outline</v-icon>
        <span> {{ $t("buttons.disconnect") }} </span>
      </section>
    </section>
  </v-card>
</template>

<script>
import TooltipDescription from "@/components/widgets/grids/actions/TooltipDescription.vue";
import Divider from "@/components/widgets/indicators/Divider.vue";
import { setLogout } from "@/services/users";
import { mapActions } from "vuex";

export default {
  name: "NavbarMenuOptions",

  props: {
    connectedUser: {
      type: Object,
    },
  },

  methods: {
    ...mapActions([
      "changeChangeUnityProfileStatus",
      "changePasswordModalStatus",
    ]),

    logout() {
      setLogout();
    },

    openResetPassword() {
      this.changePasswordModalStatus(true);
    },
  },

  components: { Divider, TooltipDescription },
};
</script>

<style lang="scss" scoped>
.menu__card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  max-width: 269px;

  .menu__user__data {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .header {
      display: flex;
      align-items: center;
      gap: 8px;

      .v-icon {
        background: #f1f8ff;
        border-radius: 50%;
        padding: 2px;
      }

      .user__name {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 0;

        span {
          font-size: 13px;
          font-weight: 600;
          text-transform: uppercase;
        }

        small {
          font-size: 10px;
          text-transform: lowercase;
        }
      }
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: 8px;
      background: #fafafa;
      padding: 10px;
      border-radius: 10px;

      .detail {
        display: flex;
        flex-direction: column;

        small {
          font-size: 10px;
        }

        span {
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .action {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      border: 1px solid #e4e4e4;
      padding: 10px;
      border-radius: 10px;
      cursor: pointer;
      transition: 0.4s;

      .v-icon {
        position: absolute;
        left: 30px;
      }

      span {
        font-size: 12px;
        font-weight: 500;
      }

      &:hover {
        transition: 0.4s;
        border-color: #0c6edf;
        color: #0c6edf;

        .v-icon {
          color: #0c6edf;
        }
      }

      &--logout:hover {
        transition: 0.4s;
        border-color: #fc5658;
        color: #fc5658;

        .v-icon {
          color: #fc5658;
        }
      }
    }
  }
}
</style>
